import styled from "@emotion/styled";

export const StyleWrapper = styled.div`
    .fc-button-primary{
        padding: 6px 18px;
        color: #1A1C21;
        background: #FCFCFC;
        border: 1px solid #DEDEDE;
        &:hover{
            color: #FCFCFC;
            background: #1A1C21;
        }
        &:focus {
            box-shadow: none !important;
        }
        &.timeSelected{
            background: #1A1C21;
            color: #FCFCFC;
            border: 1px solid #1A1C21;
        }
    }
    .fc-prevButton-button,
    .fc-nextButton-button{
        padding: 6px 12px;
        border: none;
    }
    .fc-col-header-cell-cushion{
        font-weight: 400;
        text-transform: capitalize;
        color: #8E8E8E;
    }
    .fc-day-today{
        background: #f1f1f1;
        .fc-daygrid-day-number{
            padding: 4px 8px;
            color: #FCFCFC;
            background: #1A1C21;
            border-radius: 100px;
        }
    } 
    .fc-toolbar-title{
        font-size: 24px;
        font-weight: 500;
        text-transform: capitalize;
    }
    .fc-timegrid-axis-frame,
    .fc-timegrid-slot-label-frame{
        text-align: center;
    }
`;